import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useUserDetails } from "@/hooks/api/useUserDetails";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();
  const { data: userDetails, isLoading: isLoadingUserDetails } = useUserDetails();

  // Show loading state while checking auth and user details
  if (isLoading || isLoadingUserDetails) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
      </div>
    );
  }

  // Not authenticated - redirect to auth
  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  // Authenticated but onboarding not complete - redirect to onboarding
  if (userDetails && !userDetails.completedOnboarding && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }

  // All checks passed - render the protected content
  return <>{children}</>;
};

export default ProtectedRoute;